
// => Styling
import styles from './Thermometer.module.css';

// => Icons
import { 
    IoThermometerOutline,
    IoAlertCircle,
} from "react-icons/io5";

// => React hooks
import { cloneElement } from 'react';


// ============
// Component
// ============
const Thermometer = ({
    current = 50,
    min = 0,
    max = 100,
    icon = <IoThermometerOutline />,
    alertIcon = <IoAlertCircle />,
    colorCold = "#c4c4c4",
    colorHot = "#ff317c",
    size = "36px",
    showValue = false,
    iconRotated = false,
}) => {

    const getClipValue = () => {
        let value = max - current
        if (iconRotated === false) return 'inset(' + value + '% 0 0 0)'
        else return 'inset(0 0 ' + value + '% 0)'
    }

    /* As seen on: https://gist.github.com/nikolas/b0cce2261f1382159b507dd492e1ceef */
    const lerpColor = (a, b, amount) => {

        // Added this myself
        // Don't bother if both colors are the same
        if (a === b) return a;

        var ah = parseInt(a.replace(/#/g, ''), 16),
        ar = ah >> 16, ag = (ah >> 8) & 0xff, ab = ah & 0xff,
        bh = parseInt(b.replace(/#/g, ''), 16),
        br = bh >> 16, bg = (bh >> 8) & 0xff, bb = bh & 0xff,
        rr = ar + amount * (br - ar),
        rg = ag + amount * (bg - ag),
        rb = ab + amount * (bb - ab);

        return '#' + ((1 << 24) + (rr << 16) + (rg << 8) + rb | 0).toString(16).slice(1);
    }

    const getAlertSpeed = () => {
        
        if (current >= 80) {
            return "400ms"
        } else if (current >= 60) {
            return "1000ms"
        } else if (current >= 40) {
            return "1600ms"
        } else {
            return "0"
        }
    }


    // RENDER
    // ---------
    return(
        <div className={styles.container} style={{
            width: size,
            height: size
        }}>
            { ((current > 40) && alertIcon) &&
            <IoAlertCircle className={styles.alert} style={{ animationDuration: getAlertSpeed(), }} />
            }
            {cloneElement(icon, { className: [styles.bg, icon?.props.className].join(" ")})}
            {/*<IoThermometerOutline className={styles.bg} />*/}
            {/*<IoThermometerOutline className={styles.fill} style={{
                color: lerpColor(colorCold, colorHot, current/100),
                clipPath: getClipValue()
            }} />*/}
            {cloneElement(icon, { className: [styles.fill, icon?.props.className].join(" "),
                                  style: { color: lerpColor(colorCold, colorHot, current/100),
                                            fill: lerpColor(colorCold, colorHot, current/100),
                                            clipPath: getClipValue()}})}

            {(showValue === true) &&
                <span className={styles.value}>{current}</span>
            }
        </div>
    )
}


export default Thermometer